<template>
  <div
    class="color-selector__color-box"
    :class="{ 'is-selected': currentVariantId === variant.id }"
    :key="variant.id"
    @click.prevent="selectColor($event, variant.id)"
  >
    <div
      class="color-selector__color color-selector__color--primary"
      :style="`background-color: ${variant.colorCodePrimary}`"
    ></div>
    <div
      class="color-selector__color color-selector__color--secondary"
      :style="`background-color: ${variant.colorCodeSecondary}`"
    ></div>
  </div>
</template>

<script>
import {
  notifyExternalServices,
  ACTIONS,
} from '@/services/external-communication/external-communication'
import settings from '@/components/_shared/Cards/card-settings'

const ANIMATION_DURATION = 400

export default {
  name: 'ColorBox',

  props: {
    variant: {
      type: Object,
      required: true,
    },
    currentVariantId: {
      type: Number,
      required: true,
    },
    onColorSelect: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      maleVariants: [],
      femaleVariants: [],
    }
  },

  methods: {
    async animateVariantImageChange() {
      document.body.classList.add(settings.transitionClass)
      setTimeout(() => document.body.classList.remove(settings.transitionClass), ANIMATION_DURATION)
    },

    selectColor() {
      if (this.currentVariantId === this.variant.id) return
      this.animateVariantImageChange()
      this.onColorSelect(this.variant.id)

      notifyExternalServices({
        action: ACTIONS.productInteraction,
        details: {
          action: 'color_select',
          label: `${this.variant.spreeProduct.groupName} || ${this.variant.colorName}`,
        },
      })
    },
  },
}
</script>
